import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CardEntity } from '../../domain/entities/CardEntity'
import type { CardAdminDto } from '@/backend/market'

export class CardModel extends CardEntity {
  constructor(dataDto: CardAdminDto) {
    super()
    const newRegions = dataDto.cardRegions?.map((item) => {
      const result = {
        id: item.id,
        name: item.name
      }
      return result
    })
    mapEntityProperties<CardEntity>(this, dataDto, {
      map: {
        channel: {
          id: dataDto.channelId,
          name: dataDto.channelName
        },
        regions: newRegions,
        cardRegions: dataDto.cardRegions?.map((item) => {
          return {
            region: {
              id: item?.id,
              name: item?.name
            },
            districtIds: item.districtIds
          }
        })
      }
    })
  }
}
